/** Shared attachment constraints used by the wire contract and persisted schema. */
export const CARE_CHAT_ATTACHMENT_MAX_SIZE_BYTES = 10_485_760;

export const CARE_CHAT_ATTACHMENT_ALLOWED_MEDIA_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'application/pdf',
] as const;

/** An attachment MIME type the shared care-chat contract accepts. */
export type CareChatAttachmentMediaType = (typeof CARE_CHAT_ATTACHMENT_ALLOWED_MEDIA_TYPES)[number];

/**
 * Boundary guard: narrows an untrusted MIME string (a browser `File.type`,
 * picker metadata, a raw request-body field) to the shared allowed set.
 */
export function isAllowedCareChatAttachmentMediaType(
  value: unknown,
): value is CareChatAttachmentMediaType {
  return (
    typeof value === 'string' &&
    CARE_CHAT_ATTACHMENT_ALLOWED_MEDIA_TYPES.some((allowed) => allowed === value)
  );
}
